import { Command } from "./command.js";
function deserialize(result) {
    if (result.length === 0) {
        return null;
    }
    const obj = {};
    while (result.length >= 2) {
        const key = result.shift();
        const value = result.shift();
        try {
            obj[key] = JSON.parse(value);
        }
        catch {
            obj[key] = value;
        }
    }
    return obj;
}
/**
 * @see https://redis.io/commands/hgetall
 */
export class HGetAllCommand extends Command {
    constructor(cmd, opts) {
        super(["hgetall", ...cmd], {
            deserialize: (result) => deserialize(result),
            ...opts,
        });
    }
}
